import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, AutoLoginComponent, ForbiddenComponent, LoggedoutComponent, RedirectComponent, RefreshComponent, UnauthorizedComponent } from '@app/core';
import { MenuResolve, SubMenuResolve } from '@messaia/cdk';
import { MainComponent } from './main/main.component';

const routes: Routes = [
    {
        path: '', component: MainComponent, resolve: { menu: MenuResolve }, data: { scope: 'admin', includes: ['items.roles', 'items.items.roles'], enabled: true }, children: [
            { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
            { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule), resolve: { menu: SubMenuResolve } },
            { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule), resolve: { menu: SubMenuResolve } },

            { path: 'customers', loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule), resolve: { menu: SubMenuResolve } },
            { path: 'products', loadChildren: () => import('./products/products.module').then(m => m.ProductsModule), resolve: { menu: SubMenuResolve } },
            { path: 'orders', loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule), resolve: { menu: SubMenuResolve } },

            { path: 'fibermanagement', loadChildren: () => import('./fiber-management/fiber-management.module').then(m => m.FiberManagementsModule), resolve: { menu: SubMenuResolve } },
            { path: 'cms', loadChildren: () => import('./cms/cms.module').then(m => m.CmsModule), resolve: { menu: SubMenuResolve } },
            { path: 'cpelogistic', loadChildren: () => import('./cpe-logistic/cpe-logistic.module').then(m => m.CPELogisticModule), resolve: { menu: SubMenuResolve } },
            { path: 'issues', loadChildren: () => import('./issues/issues.module').then(m => m.IssuesModule), resolve: { menu: SubMenuResolve } },
            { path: 'logs', loadChildren: () => import('./logs/logs.module').then(m => m.LogsModule), resolve: { menu: SubMenuResolve } },

            { path: 'exports', loadChildren: () => import('./exports/exports.module').then(m => m.ExportsModule), resolve: { menu: SubMenuResolve } },
            { path: 'imports', loadChildren: () => import('./imports/imports.module').then(m => m.ImportsModule), resolve: { menu: SubMenuResolve } }
        ]
    },
    { path: 'login', component: AutoLoginComponent },
    { path: 'loggedout', component: LoggedoutComponent },
    { path: 'forbidden', component: ForbiddenComponent },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: 'refresh', component: RefreshComponent },
    { path: 'redirect', component: RedirectComponent },
    // { path: '**', redirectTo: environment.postLoginRoute, pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuard, MenuResolve, SubMenuResolve]
})
export class AppRoutingModule { }